/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureeventcover3Inputs */

const en_aifeatureeventcover3 = /** @type {(inputs: Aifeatureeventcover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI event cover`)
};

const de_aifeatureeventcover3 = /** @type {(inputs: Aifeatureeventcover3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-Cover aus der KI`)
};

/**
* | output |
* | --- |
* | "AI event cover" |
*
* @param {Aifeatureeventcover3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureeventcover3 = /** @type {((inputs?: Aifeatureeventcover3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureeventcover3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureeventcover3(inputs)
	return de_aifeatureeventcover3(inputs)
});
export { aifeatureeventcover3 as "aiFeatureEventCover" }